import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useGetLeagueStandingsQueryData } from '@/app/(default)/(leagues)/leagues/[slug]/session/[sessionId]/queries';
import { columnsMap } from '@/modules/league/details/standings/constants';
import StandingsTable from '@/modules/league/details/standings/StandingsTable';
import StandingsTableSkeleton from '@/modules/league/details/standings/StandingsTableSkeleton';
import { SessionLeagueDetails } from '@/modules/league/new-components/types';

export default function getStandingsTable(
  session: SessionLeagueDetails,
  params: { slug: string; sessionId: string }
) {
  const { data: standings, isRefetching } = useGetLeagueStandingsQueryData(
    params.sessionId,
    session?.RankingType
  );

  const hasPlayers = standings && standings?.players?.length > 0;

  const currentColumns = columnsMap[session?.RankingType];

  if (!currentColumns) return null;

  return standings && !isRefetching ? (
    !hasPlayers ? (
      <div className='my-2 w-full overflow-x-auto text-center font-semibold md:ml-4'>
        <FontAwesomeIcon className='mr-2 text-2xl' icon={faCircleExclamation} />
        <div>No Players at this time</div>
      </div>
    ) : (
      <>
        <StandingsTable
          session={session}
          players={standings.players}
          totals={session?.RankingType === 'UpDown' ? standings.totals : undefined}
          columns={currentColumns}
        />
        {session?.RankingType === 'Factors' && (
          <div className='my-4 w-full rounded-lg bg-gray-100 p-4 text-left text-sm text-gray-900 md:text-base'>
            <div className='mb-1'>
              {'This league has a '}
              <span className='font-semibold'>{`${parseFloat(session?.MaxMovementRule) * 100}%`}</span>
              {' Max Movement Rule.'}
            </div>
            <div className='mb-6'>
              {'Max Movement per player this week is '}
              <span className='font-semibold'>{`${session?.MaxMovementFromCurrentWeek}.`}</span>
            </div>
            <div>
              <span className='text-red-600'>*</span>
              {
                ' This player would have hit their Max Movement although other players, because of their Max Movement, prevented them from moving anymore '
              }
              <span className='font-semibold'>OR</span>
              {' they did not play the current week. Absent players CANNOT move up.'}
            </div>
          </div>
        )}
      </>
    )
  ) : (
    <StandingsTableSkeleton />
  );
}
